import React from 'react';
import { useLocation } from 'react-router-dom';

const NotFound = () => {
  const location = useLocation();
  return <div>Sorry, the page {location.pathname} was not found</div>;
};

export default NotFound;
